import { RiskFieldsTypeEnum } from '@/__generated__/graphql';
import { RiskAssessmentDrawerTable } from '../RiskAssessmentDrawerTable';

export const TransitionPeriodTab = () => {
  const selectedTab = RiskFieldsTypeEnum.TransitionPeriod;

  return <RiskAssessmentDrawerTable selectedTab={selectedTab} />;
};
